const Bottom = () => {
  return (
    <div className="border-t dark:border-t-0 dark:bg-gray-900">
      <div className="container-block py-4">
        <p className="text-[13px] font-medium text-center dark:text-white">
          Copyright &copy; {new Date().getFullYear()} Designed & Built by{" "}
          <span className="font-semibold text-sm text-teal-900 dark:text-teal-400">
            Shakil Khan
          </span>
        </p>
      </div>
    </div>
  );
};

export default Bottom;
